import { MAX_ZOOM, MIN_ZOOM, nextZoomStep, zoomAt } from '@kanvas/board-core';
import { zoomToFit, zoomToSelection, type ActionContext } from '../actions/actions';
import { useEditor } from '../state/store';
import { Popover } from './controls';
import { Icon } from './icons';

export function ZoomControls({ ctx }: { ctx: ActionContext }) {
  const zoom = useEditor((s) => s.viewport.zoom);
  const showMinimap = useEditor((s) => s.showMinimap);
  const hasSelection = useEditor((s) => s.selection.length > 0);

  // Zoom from the viewport centre, which is what a keyboard or button zoom
  // should do; pointer-anchored zoom is the wheel handler's job.
  const zoomTo = (next: number) =>
    useEditor.getState().setViewport((vp) =>
      zoomAt(vp, next, { x: vp.width / 2, y: vp.height / 2 }),
    );

  return (
    <div className="zoom-controls">
      <button
        type="button"
        className="zoom-btn"
        title="Показать миникарту"
        aria-pressed={showMinimap}
        onClick={() => useEditor.getState().setUi({ showMinimap: !showMinimap })}
      >
        <Icon name="map" size={16} />
      </button>

      <div className="zoom-group">
        <button
          type="button"
          className="zoom-btn"
          title="Уменьшить (Ctrl -)"
          disabled={zoom <= MIN_ZOOM + 1e-4}
          onClick={() => zoomTo(nextZoomStep(zoom, -1))}
        >
          <Icon name="minus" size={16} />
        </button>

        <Popover
          align="right"
          title="Масштаб"
          trigger={() => <span className="zoom-value">{Math.round(zoom * 100)}%</span>}
        >
          {(close) => (
            <div className="popover-stack">
              <button
                type="button"
                className="menu-item"
                onClick={() => {
                  zoomToFit(ctx);
                  close();
                }}
              >
                Вписать в экран <kbd>Shift 1</kbd>
              </button>
              <button
                type="button"
                className="menu-item"
                disabled={!hasSelection}
                onClick={() => {
                  zoomToSelection(ctx);
                  close();
                }}
              >
                Приблизить к выделению <kbd>Shift 2</kbd>
              </button>
              {[0.5, 1, 2, 4].map((level) => (
                <button
                  key={level}
                  type="button"
                  className="menu-item"
                  onClick={() => {
                    zoomTo(level);
                    close();
                  }}
                >
                  {level * 100}%
                </button>
              ))}
            </div>
          )}
        </Popover>

        <button
          type="button"
          className="zoom-btn"
          title="Увеличить (Ctrl +)"
          disabled={zoom >= MAX_ZOOM - 1e-4}
          onClick={() => zoomTo(nextZoomStep(zoom, 1))}
        >
          <Icon name="plus" size={16} />
        </button>
      </div>
    </div>
  );
}
